import { render, staticRenderFns } from "./ImgNewsCard.vue?vue&type=template&id=a7444bf6&scoped=true"
import script from "./ImgNewsCard.vue?vue&type=script&lang=js"
export * from "./ImgNewsCard.vue?vue&type=script&lang=js"
import style0 from "./ImgNewsCard.vue?vue&type=style&index=0&id=a7444bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7444bf6",
  null
  
)

export default component.exports